import React from 'react';
import './VideoDescriptionMultiplayer.css';

const VideoDescriptionMultiplayer = () => {
  return (
    <section className="video-description text-center text-white">
      <h2 className="video-title mb-3">I Am Cat Multicat Madness (Multiplayer)</h2>

      <div className="container" style={{maxWidth: '400px;'}}>
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/PpjV6dkZf6o"
            allowFullScreen
            title="YouTube Video"
          ></iframe>
        </div>
      </div>
      <p className="video-text mt-4">
        <span className="bold-text">I Am Cat Multicat Madness </span> - leap into a chaotic, delightful sandbox world with up to 20 other players.
        Experience the world as a cat in shared environments where exploration, mischief, and playful interaction define the game.
      </p>
    </section>
  );
};

export default VideoDescriptionMultiplayer;
